import {TourStep} from "@app-types/tour.types.ts";
import {isElementVisible, waitForScrollToComplete} from "@tools/utils/common.tsx";
import {logInfo} from "@tools/LogsHandler.tsx";
import {TourProps} from "antd";

export const transformToTourSteps = (steps: TourStep[]) : TourProps['steps'] => {
    const tourSteps = steps.map((step) => ({
        title: step.title,
        description: step.description,
        // Ensure target returns undefined if the element doesn't exist
        target: () => getTargetElement(step),
    })) as TourProps['steps']

    // logInfo("::::::::: validTourSteps: ", tourSteps);
    return tourSteps;
}

export const getStep = (stepNumber: number, steps: TourStep[]) => steps[stepNumber]

export const getTargetElement = (step: TourStep) => {
    let elements: NodeListOf<Element> | Element | null = null;

    if (step.target.modal) {
        // Si es modal, no hay target, devuelve undefined
        return undefined;
    } else if (step.target.class) {
        // Selecciona todos los elementos con esa clase
        elements = document.querySelectorAll(step.target.class);
    } else if (step.target.id) {
        // Selecciona el elemento por ID
        elements = document.getElementById(step.target.id);
    }

    if (elements && step.onlyVisible) {
        // Si es una lista de elementos, busca el primero que sea visible
        if (elements instanceof NodeList) {
            for (let i = 0; i < elements.length; i++) {
                const element = elements[i] as HTMLElement;
                if (isElementVisible({element})) {
                    return element; // Devuelve el primer elemento visible
                }
            }
            return undefined; // Si no se encuentra un elemento visible, devuelve undefined
        }

        // Si es un único elemento, verifica su visibilidad
        if (elements instanceof HTMLElement && isElementVisible({element: elements})) {
            return elements;
        }
        return undefined; // No se encontró un elemento visible
    }

    // Si no está activado onlyVisible, devuelve el primer elemento que encuentres
    if (elements instanceof NodeList) {
        return elements[0] as HTMLElement;
    }

    return elements as HTMLElement | undefined;
};

export const getValidTourSteps = (tourSteps: TourStep[]): TourStep[] | undefined => {
    const validSteps: TourStep[] = [];

    for (const step of tourSteps) {
        const element = getTargetElement(step);

        if (!element && !step.optional && !step.target.modal && !step.target.allowHidden) {
            // Si un paso obligatorio no tiene elemento y tampoco es modal, devolvemos undefined
            return undefined;
        }

        // Para pasos opcionales sin elemento o sin visibilidad, no se añaden
        if (!((step.optional && !step.target.allowHidden) && (!element || (/*!step.executeBefore && */!isElementVisible({ element }))))) {
            validSteps.push(step);
        }

        // if ((step.optional && !element) || (step.optional && element && !step.executeBefore && !isElementVisible({element}))) {
        // } else {
        //     // Agrega pasos que tienen un elemento asociado o son modales
        //     validSteps.push(step);
        // }
    }

    logInfo('getValidTourSteps - validSteps: ', validSteps);

    return validSteps;
};


export const scrollToFirstElement = async (validSteps: TourStep[]) => {
    // Verificar si el primer paso tiene un elemento y correr waitForScrollToComplete
    const firstStep = getStep(0, validSteps); // Obtener el primer paso
    const element = getTargetElement(firstStep); // Obtener el elemento del primer paso
    if (element) {
        // Hacer scroll para centrar el elemento en la vista si está fuera del área visible
        await waitForScrollToComplete(element);
    }
}
